export type CryptoProCertificate = {
  thumbprint: string;
  name: string;
  subjectName: string;
  issuerName: string;
  validFrom: string;
  validTo: string;
};

export enum CryptoProErrorCode {
  PluginNotAvailable = 'PLUGIN_NOT_AVAILABLE',
  NoCertificates = 'NO_CERTIFICATES',
  UnknownHashAlgorithm = 'UNKNOWN_HASH_ALGORITHM',
  UserCancelled = 'USER_CANCELLED',
  SignFailed = 'SIGN_FAILED',
}

export class CryptoProError extends Error {
  readonly code: CryptoProErrorCode;

  constructor(code: CryptoProErrorCode, message: string) {
    super(message);
    this.name = 'CryptoProError';
    this.code = code;
  }
}
